<template>
  <div id="AttendanceManagement_Clock_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            差勤管理－打卡
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="Step 1.上／下班選擇"
          name="1"
          class="tab1"
        >
          <!-- <div v-if="settingData.VerifyGps" class="geolocation">
            <div class="title">打卡位置</div>
            <div class="info">
              <p>打卡規定：公司期望打卡範圍距離社區 {{ settingData.Meter }} 公尺內</p>
              <div class="status" v-if="positioningStatus === 1 || positioningStatus === 3">
                <span>目前位置</span>
                <div v-if="positioningStatus === 1" class="status">
                  <el-tag type="info" effect="dark">定位失敗</el-tag>
                  <div class="link" @click="$toExternaLink('https://www.smartdaily.com.tw/questions/7186900')">點此查看定位檢查教學</div>
                </div>
                <el-tag v-else type="success" effect="dark">正常</el-tag>
              </div>
              <span v-else>目前定位位置離社區較遠，請確認是否在社區內完成上下班打卡</span>
            </div>
          </div> -->
          <div class="btnGroup">
            <div
              class="thumbnail"
              @click="ClockIn"
            >
              <i
                class="icon-gotowork"
                aria-hidden="true"
              />
              <div class="caption">
                上班
              </div>
            </div>
            <div
              class="thumbnail"
              @click="ClockOut"
            >
              <i
                class="icon-offwork"
                aria-hidden="true"
              />
              <div class="caption">
                下班
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="Step 2.打卡"
          name="2"
          :disabled="type === ''"
        >
          <div class="step2">
            <WebCam
              ref="webcam"
              :fixed="false"
              :onside="false"
              :web-cam-size="webCamSize"
              @takephoto="takephoto"
            />
            <div
              v-if="webcamReady"
              class="webcamTip"
            >
              請確實拍攝管理人員影像
            </div>
            <div
              v-if="webcamReady"
              class="webcamBtn"
              @click="waitWebCamReady()"
            >
              <i
                class="icon-photo-camera"
                aria-hidden="true"
              />
            </div>
            <div
              v-if="webcamReady === false"
              class="webcamNotReady"
            >
              <p>網路攝影機 載入中...</p>
              <p>請選擇相機權限</p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <ClockIn
      ref="ClockIn"
      @backStep1="backStep1"
    />
    <ClockOut
      ref="ClockOut"
      @backStep1="backStep1"
    />
  </div>
</template>
<script>
import WebCam from '@/components/WebCam'
import ClockIn from './components/ClockIn'
import ClockOut from './components/ClockOut'
import getCoordinateDistance from '@/components/Mixins/getCoordinateDistance'

export default {
  components: {
    WebCam,
    ClockIn,
    ClockOut
  },
  mixins: [getCoordinateDistance],
  beforeRouteEnter (to, from, next) {
    console.log(to)
    next(vm => {
      axios(`${process.env.VUE_APP_CORE_URL}/api/Auth/UserInfo`, {
        method: 'GET',
        headers: {
          kingnetauth: `Cookies ${vm.$getCookie('comLoginToken').replace('token=', '')}`
        }
      }).then((res) => {
        console.log(res.data.Data)
        if (res.data.Data.IsAuthorizationAccount === false) {
          vm.$alert('您無權限操作此功能，請使用手機帳號重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            vm.$toMainPage()
            return false
          })
        } else {
          next()
        }
      }).catch((err) => {
        console.log(err)
      })
    })
  },
  data () {
    return {
      activeName: '1',
      webCamSize: {
        w: 640,
        h: 400
      },
      openWebCam: false,
      webcamUrl: '',
      webcamFile: null,
      type: '',
      latitude: 0,
      longitude: 0,
      isWarning: false,
      settingData: { // 物業雲與EIP設定資料
        Meter: 0,
        VerifyGps: false
      },
      positioningStatus: 1,
      webcamReady: false // webcam 是否初始化完畢
    }
  },
  mounted () {
    this.webCamInit()
    this.longitude = this.$store.state.position.longitude
    this.latitude = this.$store.state.position.latitude
    apiAttendanceManagement.GetCommunityClockAuth().then(res => {
      if (res.status === 200) {
        if (res.data.Data.IsOpenCrossCommunityClock) { // 有開啟跨案場打卡
          localStorage.setItem('CrossCommunityClock', JSON.stringify(res.data.Data))
          this.settingData = res.data.Data
        } else {
          this.$toPage('serviceManager_clock')
        }
      }
    }).catch(err => {
      console.log('錯誤訊息：', err.response)
    })
  },
  methods: {
    ClockIn () {
      this.activeName = '2'
      this.type = 'ClockIn'
    },
    ClockOut () {
      this.activeName = '2'
      this.type = 'ClockOut'
    },
    webCamInit () {
      this.webcamReady = false
      this.$refs.webcam.init().then(res => {
        this.webcamReady = true
        if (res === '未開啟攝影機') {
          this.openWebCam = false
        } else {
          this.openWebCam = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    waitWebCamReady () {
      let waitWebCamReady = setInterval(() => {
        if (this.webcamReady) { // webcam 完成
          clearInterval(waitWebCamReady)
          waitWebCamReady = null
          this.getPicture()
        }
      }, 100)
    },
    // 拍照
    getPicture () {
      const data = {
        webcamUrl: '',
        webcamFile: null,
        latitude: this.latitude,
        longitude: this.longitude,
        isWarning: this.isWarning
      }
      if (this.openWebCam) {
        console.log('有開相機')
        this.$refs.webcam.getPicture()
        let waittakephoto = setInterval(() => {
          if (this.webcamUrl && this.webcamFile) {
            clearInterval(waittakephoto)
            waittakephoto = null
            data.webcamUrl = this.webcamUrl
            data.webcamFile = this.webcamFile
            if (this.type === 'ClockIn') {
              this.$refs.ClockIn.startClockIn(data)
            } if (this.type === 'ClockOut') { this.$refs.ClockOut.startClockOut(data) }
          }
        }, 100)
      } else {
        this.$confirm('未擷取影像仍繼續打卡?', '警告', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.type === 'ClockIn') {
            this.$refs.ClockIn.startClockIn(data)
          } if (this.type === 'ClockOut') { this.$refs.ClockOut.startClockOut(data) }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // WebCam拍照後回調函式
    takephoto (url) {
      const day = new Date()
      this.webcamUrl = url
      let filetype = this.webcamUrl.split('/')
      filetype = filetype[1].split(';')
      this.webcamFile = dataURLtoFile(url, `${day.getFullYear()}${('0' + (day.getMonth() + 1)).slice(-2)}${('0' + day.getDate()).slice(-2)}${('0' + day.getHours()).slice(-2)}${('0' + day.getMinutes()).slice(-2)}${('0' + day.getSeconds()).slice(-2)}${day.getMilliseconds()}.${filetype[0]}`)
      function dataURLtoFile (url, filename) { // 將base64轉換為檔案
        const arr = url.split(','); const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1]); let n = bstr.length; const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
      }
    },
    // 計算座標
    calculatedCoordinates () {
      if (this.settingData.VerifyGps === true) {
        if (this.settingData.Coordinate !== null) {
          const meter = this.getCoordinateDistance(this.settingData.Coordinate.Longitude, this.settingData.Coordinate.Latitude, this.longitude, this.latitude)
          console.log(meter)
          if (meter > this.settingData.Meter) {
            this.isWarning = true
            this.positioningStatus = 2
          } else {
            this.isWarning = false
            this.positioningStatus = 3
          }
        } else {
          this.isWarning = true
        }
      } else {
        this.isWarning = false
      }
    },
    backStep1 () {
      this.activeName = '1'
      this.type = ''
    }
  }
}
</script>
<style lang="sass" scoped>
#AttendanceManagement_Clock_main
  +mainLayer
  .el-tabs
    +TabsToSteps
    .tab1
      padding-top: 30px
    .geolocation
      position: relative
      margin: 0px auto
      width: 590px
      .title
        position: absolute
        top: 0
        left: 0
        width: 120px
        height: 80px
        background-color: $mainColor
        color: $white
        line-height: 80px
        font-size: 22px
        border-radius: $pageBorderRadius
      .info
        width: 460px
        padding-left: 130px
        padding-top: 10px
        padding-bottom: 10px
        height: 60px
        background-color: $bgDark3
        border-top-right-radius: $pageBorderRadius
        border-bottom-right-radius: $pageBorderRadius
        font-size: 16px
        line-height: 30px
        text-align: left
        margin-bottom: 20px
        .status
          display: flex
          .el-tag
            line-height: 30px
            height: 30px
            margin: 0px 10px
          .link
            text-decoration: underline
            color: $blueColor
            cursor: pointer
            font-size: 14px
            &.link2
              margin-left: 5px
    .btnGroup
      display: flex
      width: 490px
      margin: 0px auto 40px
    .thumbnail
      flex: 0 0 215px
      background-color: $white
      margin: 15px
      text-align: center
      display: flex
      align-items: center
      justify-content: center
      flex-wrap: wrap
      cursor: pointer
      box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3)
      border-radius: 8px
      &:hover
        background-color: $whiteHover
      i
        width: 100%
        height: 30%
        margin-top: 45px
        margin-bottom: 10%
        color: $mainColor
        font-size: 60px
      .caption
        font-size: 30px
        color: #4B4B4B
        margin-bottom: 35px
        margin-top: 15px
  .step2
    width: 640px
    height: 400px
    position: relative
    margin: 0 auto
  ::v-deep .webcamDiv
    position: relative
    left: -30px
    .webcam-wrap-notonside
      display: none
    .webcam
      border: 0
      margin-top: 0
      margin-right: 0
      width: 640px
      height: 400px
      video
        width: 640px
        height: 400px
    .pic-wrap
      display: none
    .noWebcam
      background-repeat: no-repeat
      background-size: contain
  .webcamTip
    position: absolute
    top: 355px
    left: 370px
    background-color: #ffcc01
    height: 22px
    padding: 5px 8px
    line-height: 22px
    border-radius: $pageBorderRadius
  .webcamBtn
    position: absolute
    top: 0
    left: 571px
    height: 400px
    width: 80px
    background-color: $mainFontColor
    cursor: pointer
    .icon-photo-camera
      color: $white
      font-size: 36px
      line-height: 400px
  .webcamNotReady
    position: absolute
    top: 0
    left: 0
    margin: 0px auto
    width: 640px
    height: 240px
    background-color: $borderDark3
    padding-top: 160px
    p
      &:nth-child(1)
        font-size: 20px
      &:nth-child(2)
        font-size: 16px
        font-weight: bold
        line-height: 40px
</style>
